import { Grid2, InputBase, Typography } from '@mui/material';
import { helperText } from '../assets/theme/Theme';

interface TextInputProps {
	inputTitle: string;
	value?: string;
	onChange: (value: string) => void;
	inputError: { status: boolean; msg: string };
}

function TextInput({
	inputTitle,
	value,
	onChange,
	inputError,
}: TextInputProps) {
	function onChangeHandler(
		event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
	) {
		onChange(event.target.value);
	}

	return (
		<>
			<Typography
				fontSize={'16px'}
				color={'#7C7C7C'}
				paddingBottom="10px">
				{inputTitle}
			</Typography>
			<Grid2
				container
				justifyContent={'space-between'}
				alignItems={'center'}
				border={
					inputError.status ? '1px solid red' : '1px solid #D9D9D9'
				}
				color={'#777E90'}
				paddingX={'15px'}
				borderRadius={'5px'}>
				<InputBase
					type={'text'}
					sx={{
						padding: '4px',
						width: '100%',
						color: '#777E90',
					}}
					error={inputError.status}
					onChange={onChangeHandler}
					// onKeyPress={e => e.code === 'Enter' && logIn()}
				/>
			</Grid2>
			<Typography style={helperText}>{inputError.msg}</Typography>
		</>
	);
}

export default TextInput;
